import { render, staticRenderFns } from "./ImageRss.vue?vue&type=template&id=1aeaf59a"
import script from "./ImageRss.vue?vue&type=script&lang=js"
export * from "./ImageRss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports